var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m59.152 49.688l19.887-19.887v-0.003906c0.58594-0.58594 0.91797-1.3789 0.91797-2.207s-0.33203-1.625-0.91797-2.2109l-4.418-4.418c-1.2188-1.2227-3.1992-1.2227-4.418 0l-19.887 19.887-19.887-19.887h-0.003907c-1.2188-1.2227-3.1992-1.2227-4.418 0l-4.418 4.418c-1.2227 1.2188-1.2227 3.1992 0 4.418l19.887 19.891-19.887 19.887h-0.003906c-1.2188 1.2188-1.2188 3.1992 0 4.418l4.4219 4.418c1.2188 1.2227 3.1992 1.2227 4.418 0l19.887-19.887 19.887 19.887h0.003906c0.58594 0.58984 1.3789 0.91797 2.207 0.91797s1.625-0.32812 2.2109-0.91797l4.418-4.418c0.58594-0.58594 0.91797-1.3789 0.91797-2.2109 0-0.82812-0.33203-1.6211-0.91797-2.207z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.7fd360cffdc4cf2a0a46500d4b3c63bb.svg";
export { ForwardRef as ReactComponent };